module.exports = {
    PLACE: 0,
    BUSINESS: 1,
    EVENT: 2,
    GOOGLE: 3
}